import React from 'react'
import "./Coding.css"


// const steps = [
//     {
//       title: 'First',
//       content: 'First-content',
//     },
//     {
//       title: 'Second',
//       content: 'Second-content',
//     },
//     {
//       title: 'Last',
//       content: 'Last-content',
//     },
//   ];

// const steps = [
//     {
//       title: 'First',
//       content: 'First-content',
//     },
//     {
//       title: 'Second',
//       content: 'Second-content',
//     },
//     {
//       title: 'Last',
//       content: 'Last-content',
//     },
//   ];
function Coding() {
   
    return(
        <>
        <div className="codingContainer">
            <h1>Question</h1>
            <textarea name=""  id="" cols="70" rows="10"></textarea>
        </div>
        </>
    )
}

export default Coding